import { InvoiceDetails } from 'src/app/business/models/billing/invoice-details.model';

export class BillingUtils {

    public static getInvoiceNameToDownload(invoiceDetails: InvoiceDetails): string {
         return `${invoiceDetails.invoiceDate}-${invoiceDetails.serialNumber}.pdf`;
    }

}
